const base = `${process.env.REACT_APP_BACKEND_URL}`;
const endpoints = {
  make_post: `${base}/post`,
  get_all_posts: `${base}/post`,
  my_posts: `${base}/post/current-user`,
  update_post_status: `${base}/post/update_post`,
};

export default endpoints;
